import { render, staticRenderFns } from "./emptyTableList.vue?vue&type=template&id=4deba1d2&scoped=true"
import script from "./emptyTableList.vue?vue&type=script&lang=js"
export * from "./emptyTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deba1d2",
  null
  
)

export default component.exports